import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../../../../../reducers/types";
import {
  confirmHotelCfarCancellation,
  fetchHotelCfarCancellationPolicy,
  resetHotelCfarCancellation,
} from "../../../../../../actions/actions";
import {
  getConfirmHotelCfarCancellationCallState,
  getHotelCfarCancellationPolicy,
  getHotelCfarCancellationPolicyCallExpires,
  getHotelCfarCancellationPolicyCallState,
  getHotelCfarCancellationPolicyScenario,
  getSelectedHotelCfarReservationId,
} from "../../../../../../reducer/selectors";

import { CfarHotelModalContent } from "./component";

const mapStateToProps = (state: IStoreState) => {
  const hotelCfarCancellationPolicyCallExpires =
    getHotelCfarCancellationPolicyCallExpires(state);

  return {
    hotelCfarCancellationPolicyCallState:
      getHotelCfarCancellationPolicyCallState(state),
    hotelCfarCancellationPolicyScenario:
      getHotelCfarCancellationPolicyScenario(state),
    isHotelCfarCancellationPolicyCallExpired:
      hotelCfarCancellationPolicyCallExpires != null &&
      hotelCfarCancellationPolicyCallExpires < Date.now(),
    hotelCfarCancellationPolicy: getHotelCfarCancellationPolicy(state),
    selectedHotelCfarReservationId: getSelectedHotelCfarReservationId(state),
    confirmHotelCfarCancellationCallState:
      getConfirmHotelCfarCancellationCallState(state),
  };
};

const mapDispatchToProps = {
  fetchHotelCfarCancellationPolicy,
  resetHotelCfarCancellation,
  confirmHotelCfarCancellation,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ICfarHotelModalContentConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedCfarHotelModalContent = connector(
  withRouter(CfarHotelModalContent)
);
